import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from '@hooks/Auth';
import { CompanyRole, UserType } from '@sdk/API';

export interface PrivateRouteProps extends RouteProps {
  admin?: boolean;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  admin = false,
  children,
  ...rest
}) => {
  const { user, dbUser, loading, company } = useAuth();
  console.log('cai dkm');
  const isAdmin =
    dbUser?.type === UserType.ADMINISTRATOR ||
    company?.role === CompanyRole.ADMIN ||
    company?.role === CompanyRole.REPRESENTATIVE;

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (loading) return <div></div>;
        console.log(location.pathname);
        if (location.pathname !== '/login' && !user)
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location.pathname },
              }}
            />
          );

        if (location.pathname !== '/verify' && !user.attributes.email_verified)
          return (
            <Redirect
              to={{
                pathname: `/verify`,
              }}
            />
          );

        if (location.pathname !== '/profile/setup' && !dbUser?.setupProfile)
          return (
            <Redirect
              to={{
                pathname: '/profile/setup',
              }}
            />
          );

        if (admin && !isAdmin)
          return (
            <Redirect
              to={{
                pathname: '/',
              }}
            />
          );

        return children;
      }}
    />
  );
};

export default PrivateRoute;
